<template>
    <v-container>
        <entity-filter
            class="mb-n1"
            :isLoading="isLoading"
            :useEvents="true"
            :teams="teams"
            :hideStatus="true"
            :hideSearch="true"
            @change="filterChange"
        ></entity-filter>
        <event-time-table
            v-if="selectedEvent"
            :event="event"
            :slot-data="filteredEventSlots"
            :monster-slots="monsterSlots"
            :show-monster-slots="true"
            read-route-name="editEventSlots"
            :read-only="isReadOnly"
            @slotSelected="handleSlotSelected"
        />
    </v-container>
</template>
<script>
import api from '@/api'
import { mapState, mapGetters } from 'vuex'
import { sortBy } from 'lodash'
import EventTimeTable from '../../components/EventTimeTable.vue'
import EntityFilter from '../../components/EntityFilter.vue'
import permissions from '@/components/permissions'
import sortFilters from '@/components/sortFilters'
export default {
    name: 'EventSlotTimetable',
    components: {
        'event-time-table': EventTimeTable,
        'entity-filter': EntityFilter,
    },
    data() {
        return {
            isLoading: false,
            selectedEvent: null,
            selectedTeam: null,
            eventSlots: [],
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'Type',
                    align: 'start',
                    value: 'eventSlotType',
                },
                {
                    text: 'Date/Time',
                    align: 'start',
                    value: 'day',
                    width: '20%',
                },
                { text: 'Team', value: 'teamName', filterable: false, width: '15%' },
            ],
        }
    },
    watch: {
        selectedEvent() {
            this.getEventSlots()
        },
        currentEvent() {
            this.selectedEvent = this.currentEvent
        },
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'currentEvent']),
        filteredEventSlots() {
            let eventSlots = this.eventSlots
            if (this.selectedStatus != null) {
                eventSlots = eventSlots.filter(x => x.statusId == this.selectedStatus)
            }
            if (this.selectedTeam > 0) {
                eventSlots = eventSlots.filter(x => x.teamId == this.selectedTeam)
            }
            return eventSlots.map(x => {
                return {
                    dayId: x.day.id,
                    time: x.timeAsMinutes,
                    duration: x.durationMinutes,
                    text: `${x.eventSlotType.replace(/([A-Z])/g, ' $1')} ${x.teamName ? ` - ${x.teamName}` : ''}${
                        x.comment ? ` - ${x.comment}` : ''
                    }`,
                    id: x.id,
                }
            })
        },
        monsterSlots() {
            return this.eventSlots
                .filter(x => x.eventSlotTypeId === 1)
                .map(x => {
                    return {
                        dayId: x.day.id,
                        time: x.timeAsMinutes,
                        duration: x.durationMinutes,
                        text: `${x.comment}`,
                        id: x.id,
                    }
                })
        },
        event() {
            if (!this.selectedEvent || !this.events || this.events.length === 0) return
            let event = this.events.find(x => x.id === this.selectedEvent)
            return event
        },
        isReadOnly() {
            // this is clunky
            return !this.userPermission.includes(permissions.Edit)
        },
        userPermission() {
            if (this.user && this.user[this.entity]) {
                return this.user[this.entity].all
            } else {
                return []
            }
        },
        teams() {
            if (!this.eventSlots || this.eventSlots.length === 0) return []
            return sortFilters.uniqueTeamsForEntities(this.eventSlots, true)
        },
    },
    mounted() {
        if (this.currentEvent) {
            this.selectedEvent = this.currentEvent
        }
    },
    methods: {
        getEventSlots() {
            if (!this.selectedEvent) return
            this.isLoading = true
            let apiUrl = `/eventslots?eventId=${this.selectedEvent}`
            api.get(apiUrl)
                .then(res => {
                    this.eventSlots = this.sort(res)
                })
                .finally(() => (this.isLoading = false))
        },
        filterChange(filterState) {
            this.selectedTeam = filterState.selectedTeam
            this.selectedEvent = filterState.selectedEvent
            this.getEventSlots()
        },
        sort(eventSlots) {
            return sortBy(eventSlots, ['day.date', 'timeAsMinutes'])
        },
        getEncounterDayAndTime(encounter) {
            return this.getTimeStamp(encounter.day.date, encounter.timeAsMinutes)
        },
        getAllTeam() {
            return [{ value: 0, text: 'All' }]
        },
        handleSlotSelected(day, time) {
            if (this.selectedEvent) {
                this.$router.push({
                    name: 'newEventSlot',
                    params: { startingEvent: this.selectedEvent, startingDay: day, startingTime: time },
                })
            }
        },
    },
}
</script>
